(function (root) {
  'use strict';
  const tones = ['Neutro','Rosado','Variado'];
  const themes = ['Sin Temática', 'Día de la Madre', 'Corazones', 'Animales', 'Deportes'];
  function requiredProduct(catalog, handle) {
    const p = catalog.products[handle];
    if (!p || !p.id || !p.available || !Number.isSafeInteger(p.price) || p.price < 0)
      throw new Error('Esta combinación no está disponible ahora. Puedes elegir otra opción o consultarnos.');
    return p;
  }
  function quote(catalog, selection, group) {
    if (!['single','pareja','pareja-xl'].includes(selection.offer)) throw new Error('Elige una composición.');
    if (!['small','large'].includes(selection.size)) throw new Error('Elige un tamaño.');
    if (!tones.includes(selection.tone1) || !tones.includes(selection.tone2)) throw new Error('Elige una tonalidad válida.');
    validateLetters(selection);
    const pair = selection.offer !== 'single';
    const large = selection.offer === 'pareja-xl' || (!pair && selection.size === 'large');
    const theme1 = selection.theme1 || 'Sin Temática';
    const theme2 = pair ? selection.theme2 || 'Sin Temática' : 'Sin Temática';
    if (!themes.includes(theme1) || !themes.includes(theme2)) throw new Error('Elige una temática disponible.');
    const noteEnabled = selection.noteEnabled === true;
    const message = noteEnabled ? String(selection.message || '').trim() : '';
    if (message.length > 120) throw new Error('El mensaje puede tener hasta 120 caracteres.');
    const properties = {_FAS_group: group, _FAS_offer:selection.offer, _FAS_card_policy:'large-only-v1', 'Preparación':'Letras terminadas',
      'L1 — Escoge tu letra': selection.letter1.toUpperCase(), 'L1 — Tonalidad*':selection.tone1,
      'L1 — Tamaño*':large?'Grande (19 cm)':'Medio (10 cm)', 'L1 — ¿Cómo la prefieres?':'Lista para decorar', 'L1 — Temática*':theme1};
    if (pair) Object.assign(properties, {'L2 — Escoge tu letra':selection.letter2.toUpperCase(),
      'L2 — Tonalidad*':selection.tone2,'L2 — Tamaño*':large?'Grande (19 cm)':'Medio (10 cm)',
      'L2 — ¿Cómo la prefieres?':'Lista para decorar','L2 — Temática*':theme2,'Símbolo & floral incluido':'Sí'});
    properties['Nota personalizada'] = noteEnabled ? 'Sí' : 'No';
    if (message) properties['Mensaje personalizado']=message;
    if (selection.giftWrap === true) properties['Bolsa dorada para regalo'] = 'Sí';
    const items=[];
    let total=0;
    function add(handle, quantity, props, role) {
      const p=requiredProduct(catalog,handle);
      total+=p.price*quantity;
      items.push({id:p.id,quantity,properties:Object.assign({_FAS_group:group,_FAS_role:role},props)});
    }
    add(selection.offer==='single'?'letra-floral':selection.offer==='pareja'?'pack-pareja':'pack-pareja-xl',1,properties,'principal');
    // Existing catalog charges assembly separately for single/small pair. XL includes it.
    if(selection.offer!=='pareja-xl') add('complemento-letra-montada',pair?2:1,{'Servicio':'Montaje floral incluido en la selección'},'montaje');
    if(!pair && large) add('upgrade-tamano-grande',1,{'Tamaño':'19 cm'},'tamano');
    if(selection.offer !== 'pareja-xl' && noteEnabled) add('mensaje-personalizado',1,message ? {'Mensaje':message} : {},'mensaje');
    if(theme1 !== 'Sin Temática') add('upgrade-tematica',1,{'Para':'Letra 1','Letra':selection.letter1.toUpperCase(),'Temática':theme1},'tematica1');
    if(pair && theme2 !== 'Sin Temática') add('upgrade-tematica',1,{'Para':'Letra 2','Letra':selection.letter2.toUpperCase(),'Temática':theme2},'tematica2');
    if(selection.giftWrap === true) add('sobre-dorado',1,{'Accesorio':'Sobre dorado para regalo'},'regalo');
    return {items,total,pair,large};
  }
  function validateLetters(selection) {
    if(!/^[A-Z0-9]$/i.test(selection.letter1) || (selection.offer!=='single' && !/^[A-Z0-9]$/i.test(selection.letter2)))
      throw new Error('Escribe una inicial en cada campo: una letra de A-Z o un número.');
  }
  // Compare current individual prices. This is not a former price of the pack.
  function compareInitials(catalog, selection) {
    if (!['pareja','pareja-xl'].includes(selection.offer) || selection.giftWrap === true ||
        (selection.theme1 && selection.theme1 !== 'Sin Temática') ||
        (selection.theme2 && selection.theme2 !== 'Sin Temática')) return null;
    try {
      const single = Object.assign({}, selection, {offer:'single',
        size:selection.offer === 'pareja-xl' ? 'large' : 'small',
        noteEnabled:false,message:'',giftWrap:false,theme1:'Sin Temática',theme2:'Sin Temática'});
      const amount = quote(catalog, single, 'display').total * 2;
      return amount > quote(catalog, selection, 'display').total ? amount : null;
    } catch (_) { return null; } // An unavailable individual must not block an available pack.
  }
  // Sum the actual former component prices for precisely the selected composition.
  function previousTotal(catalog, selection) {
    const current = quote(catalog, selection, 'display');
    const products = new Map(Object.values(catalog.products).map(p => [String(p.id), p]));
    const previous = current.items.reduce((sum, item) => {
      const p = products.get(String(item.id));
      const price = Number.isSafeInteger(p.compareAtPrice) && p.compareAtPrice > p.price ? p.compareAtPrice : p.price;
      return sum + price * item.quantity;
    }, 0);
    return previous > current.total ? previous : null;
  }
  const api = {quote, validateLetters, compareInitials, previousTotal};
  if(typeof module==='object' && module.exports) module.exports = api;
  else root.FASCommerce = api;
})(typeof window==='undefined'?globalThis:window);
